import React from 'react'
import dayjs from '../../../Libraries/dayjs'
import ButtonIconAbsence from '../Button/ButtonIconAbsence'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  first_day_format
} from '../../../Functions/Dates'
import {
  MODAL_ABSENCES
} from '../../../Redux/Actions/Absences'

const ToolbarRootAbsence = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.login.user)
  const date = useSelector(state => state.planning.date)
  const view = useSelector(state => state.planning.view)
  const equipe = useSelector(state => state.equipe.equipe)
  const jour = dayjs(first_day_format(date, view)).startOf('day')
  return (
    (equipe.length > 0) &&
    (
      (user.profil === 'administrateur') ||
      (user.profil === 'utilisateur')
    )
  )
    ? <ButtonIconAbsence
        data-testid="planning-absence"
        title="Déclarer une absence"
        onClick={() => {
          dispatch(MODAL_ABSENCES('', 'create', {
            jour: [jour, jour]
          }))
        }}
      />
    : null
}

export default ToolbarRootAbsence
